import { useContext, useState } from "react";
import AnimateLoader from "../../components/AnimateLoader";
import { ConfigContext } from "../../context/configContext";
import Typed from 'react-typed';
import Redes from "./Redes";
import { motion } from "framer-motion";
import { BtnMenu, Menu } from "../../components/home/_menu";
import { Next } from "../../components/home/Next";
import RenderIf from "../../components/RenderIf";
import Game from "../../components/game/Game";


const _About = ({ open, setOpen }) => {

    const config = useContext(ConfigContext);

    const { about } = config;
    const [playing, setPlaying] = useState(false);


    if (!about) {
        return <AnimateLoader />;
    }

    const textLines = [`<b class= 'fs-2'> ${about.title}</b> <br /> ${about.text} `];

    return (
        <>
            {playing && <Game setPlaying = {setPlaying} />}
            {open && <Menu open={open} setOpen={setOpen} />}
            <motion.div
                initial={{ x: '-100%' }}
                animate={{ x: 0, y: 0 }}
                exit={{ y: '150%' }}
                className="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center">
                <div className="container">
                    <Typed
                        strings={textLines}
                        typeSpeed={25}
                    />
                </div>
                <RenderIf condition={!playing}>
                    <button
                        className="btn btn-danger fs-6 btn-play"
                        onClick={() => setPlaying(true)}
                        style={{ position: 'absolute', bottom: '5rem', left: '45%', wdith: '5%' }}

                    >
                        DECORATE THIS PAGE
                    </button>
                </RenderIf>
                <Redes />
                <Next name="Portafolio" link={'/portafolio'} />
            </motion.div>
            <BtnMenu open={open} setOpen={setOpen} />
        </>
    )
}

export default _About;